<template>
  <div class="global-wrapper">
    <div class="page-wrap">
      <a-layout-content-container>
        <nuxt ref="nuxt" />

        <a-footer />
      </a-layout-content-container>
    </div>

    <client-only>
      <a-error-handler-notifier v-if="isDevelopment" />
    </client-only>

    <gtm-no-script />
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import ALayoutContentContainer from '@/components/_layout/ALayoutContentContainer'
import AErrorHandlerNotifier from 'shared/AErrorHandlerNotifier'
import GtmNoScript from 'shared/GtmNoScript/index.vue'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'

export default {
  name: 'DefaultLayout',
  components: {
    AFooter: hydrateWhenVisible(() =>
      import('@/components/_layout/AFooter/index.vue')
    ),
    GtmNoScript,
    ALayoutContentContainer,
    AErrorHandlerNotifier
  },
  mixins: [mixins.windowWidth],
  head() {
    const oneTrustScript = {
      src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
      type: 'text/javascript',
      'data-domain-script': this.$env.ONE_TRUST_SCRIPT_ID,
      defer: true
    }

    const gtmScript = {
      /** Google Tag Manager **/
      hid: 'gtm',
      innerHTML:
        '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(\n' +
        "    {'gtm.start': new Date().getTime(),event:'gtm.js'}\n" +
        '  );var f=d.getElementsByTagName(s)[0],\n' +
        "    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n" +
        "    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n" +
        `  })(window,document,'script','dataLayer','${this.$env.GTM_CONTAINER_ID}');`
    }

    return {
      script: [
        oneTrustScript,
        ...(this.$env.GTM_CONTAINER_ID ? [gtmScript] : [])
      ],
      __dangerouslyDisableSanitizersByTagID: {
        gtm: ['innerHTML']
      }
    }
  },
  computed: {
    isDevelopment() {
      return process.env.NODE_ENV === 'development'
    }
  }
}
</script>

<style lang="scss" scoped></style>
